import { Repository } from './Repository';

export default class AuthRepository extends Repository {
    constructor(serverUrl) {
        super();

        this.serverUrl = serverUrl;
        this.authRequestPrefix = '/api/v1/authentications';
    }

    login = (param) => {
        return this.getRequestPromise('post', this.serverUrl + this.authRequestPrefix + `/signin`, param);
    };

    autoLogin = (param) => {
        return this.getRequestPromise('post', this.serverUrl + this.authRequestPrefix + `/auto-signin`, param);
    };

    checkLogin = () => {
        return this.getRequestPromise('get', this.serverUrl + this.authRequestPrefix + `/signcheck`);
    };

    logout = () => {
        return this.getRequestPromise('post', this.serverUrl + this.authRequestPrefix + `/signout`);
    };

    agreeTerms = (userId, param) => {
        return this.getRequestPromise('put', this.serverUrl + this.authRequestPrefix + `/${userId}/terms`, param);
    };

    updateUserInfo = (userId, param) => {
        return this.getRequestPromise('put', this.serverUrl + this.authRequestPrefix + `/${userId}/info`, param);
    };

    updateUserAgeAgreement = (userId, param) => {
        return this.getRequestPromise('put', this.serverUrl + this.authRequestPrefix + `/${userId}/age-agreement`, param);
    };

    saveUserDeviceProfile = (userId, param) => {
        return this.getRequestPromise('post', this.serverUrl + this.authRequestPrefix + `/${userId}/device-profile`, param);
    };

    saveUserDeviceProfiles = (userId, param) => {
        return this.getRequestPromise('post', this.serverUrl + this.authRequestPrefix + `/${userId}/device-profiles`, param);
    };

    updateUserDeviceProfile = (userId, param) => {
        return this.getRequestPromise('put', this.serverUrl + this.authRequestPrefix + `/${userId}/device-profile`, param);
    };

    /**
     * [신규 회원] 약관동의 + user_device_profiles 저장을 서버 단일 로직으로 처리
     * - deviceId 등 기기 정보는 서버 정책에 맞춰 optional 처리
     */
    completeSignupWithUserDeviceProfile = (userId, param) => {
        return this.getRequestPromise('post', this.serverUrl + this.authRequestPrefix + `/${userId}/terms-and-device-profile`, param);
    };
}
